"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontStylable = exports.fontUtils = void 0;
var tslib_1 = require("tslib");
var fontUtil = tslib_1.__importStar(require("./font-utils"));
exports.fontUtils = fontUtil;
var stFonts = tslib_1.__importStar(require("./fonts-stylable"));
exports.fontStylable = stFonts;
//# sourceMappingURL=index.js.map